module.exports = __webpack_public_path__ + "img/zuijia_39.277f0441.png";